import { Common } from '@stockbit/ui';
import { MainWrapper, TitleWrapper, BodyWrapper, ReadMore } from './styled';

const { Text } = Common;

interface GuestCompanyBackgroundProps {
  companyProfile: any;
  className?: string;
  onClickReadMore: (...args) => void;
}

const GuestCompanyBackground = ({
  companyProfile,
  className = '',
  onClickReadMore,
}: GuestCompanyBackgroundProps) => {
  let textBody = companyProfile.background;
  const isLongText = textBody.length > 636;
  if (isLongText) textBody = `${textBody.slice(0, 636)}...`;

  return (
    <MainWrapper className={className}>
      <TitleWrapper>
        <h2>Company Background</h2>
      </TitleWrapper>
      <BodyWrapper>
        <Text family="regular" size="12px">
          {textBody}{' '}
          {isLongText && (
            <ReadMore onClick={() => onClickReadMore(true)}>Read More</ReadMore>
          )}
        </Text>
      </BodyWrapper>
    </MainWrapper>
  );
};

export default GuestCompanyBackground;
